export const routerMisPostulaciones = [
  {
    path: '/mis-postulaciones',
    name: 'mis-postulaciones',
    component: () => import(/* webpackChunkName: "mis-postulaciones" */ '../index.vue'),
    meta: { requiresAuth: true } // Esta ruta requiere autenticación
  },
  {
    path: '/seguimiento-postulacion/:id',
    name: 'seguimiento-postulacion',
    component: () => import(/* webpackChunkName: "seguimiento-postulacion" */ '../MiProcesoPostulacion.vue'),
    meta: { requiresAuth: true } // Esta ruta requiere autenticación
  },
]